import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { looks, lookSlugs } from '@/mocks/home';
import { useMotion, useScrollExpand } from '@/hooks/useEditorialMotion';

export default function Looks() {
  const ref = useRef<HTMLElement>(null);
  useMotion(ref);
  useScrollExpand(ref);

  return (
    <section ref={ref} id="gallery" className="bg-background-50 py-16 md:py-28">
      <div className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16">
        <div data-group className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-4 mb-10 md:mb-14 items-end">
          <h2 data-m="dir" className="lg:col-span-7 font-heading font-semibold tracking-[-0.02em] leading-[1.05] text-[36px] md:text-[52px] text-foreground-950">
            <span data-dir-l className="inline-block">Selected</span> <span data-dir-r className="inline-block">Work</span>
          </h2>
          <p data-m="text" data-at="0.2" className="lg:col-span-5 text-[16px] leading-relaxed text-foreground-700">Styling directions created in the studio, from precision cuts to creative colour. Images are illustrative of our work.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10 md:gap-y-12">
          {looks.map((l, i) => (
            <Link key={l.title} to={`/work/${lookSlugs[i]}`} data-group data-m="card" className="block cursor-pointer group">
              <div data-expand className="w-full aspect-[4/5] overflow-hidden bg-background-50">
                <img src={l.src} width={800} height={1000} loading="lazy" decoding="async" alt={`${l.title} hairstyle — ${l.tag}`} title={`${l.title} — ${l.tag}`} className="w-full h-full object-cover object-top" />
              </div>
              <div className="mt-4">
                <h3 className="text-[18px] font-semibold text-foreground-950 group-hover:text-foreground-600 transition-colors duration-200">{l.title}</h3>
                <p className="mt-1 text-[14px] text-foreground-600">{l.tag}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}